import React from 'react';
import { Copy } from '@cimpress/react-components';

const CodeBlockDemo = () => {
  const textToCopy = 'TypeScript should be used for new node.js APIs.';
  return (
    <div>
      <div className="row">
        <div className="col-md-4">
          <h6>Copying the value:</h6>
          <Copy value="109313489123.49">$109,313,489,123.49</Copy>
        </div>

        <div className="col-md-4">
          <h6>Customized tooltip & Duration</h6>
          <Copy
            value={textToCopy}
            successMessage="Yay! Copied!"
            hoverText="Do the clickity click to copy to clipboard"
            duration={500}
          >
            {textToCopy}
          </Copy>
        </div>
      </div>
    </div>
  );
};

export default CodeBlockDemo;
